import _ from 'lodash';
export function getArrayFromCommaSeparatedString(input) {
    return input
        .trim()
        .split(/\s*,\s*/)
        .filter(function (x) {
        return !!x;
    });
}
export function firstN(array, N, conditionFn) {
    const arr = Object(array);
    let len = arr.length >>> 0;
    let n = 0;
    if (typeof conditionFn !== 'function') {
        if (N < 0) {
            N = 0;
        }
        return arr.slice(0, N);
    }
    const res = new Array(N);
    const thisArg = arguments.length >= 4 ? arguments[3] : void 0;
    for (let i = 0; n < N && i < len; i++) {
        if (i in arr) {
            const val = arr[i];
            if (conditionFn.call(thisArg, val, i, arr)) {
                res[n] = val;
                n++;
            }
        }
    }
    res.length = n;
    return res;
}
export function getSmallestNumberLargerThan(array, number) {
    if (!array || array.length <= 0) {
        return void 0;
    }
    let result = void 0;
    array.forEach(function (item) {
        if (item > number) {
            if (!result) {
                result = item;
            }
            else if (item < result) {
                result = item;
            }
        }
    });
    return result;
}
export function getLargestNumberSmallerThan(array, number) {
    if (!array || array.length <= 0) {
        return void 0;
    }
    let result = void 0;
    array.forEach(function (item) {
        if (item < number) {
            if (!result) {
                result = item;
            }
            else if (item > result) {
                result = item;
            }
        }
    });
    return result;
}
export function arrayTrimRight(arr) {
    arr = arr.slice();
    while (arr.length > 0 && arr[arr.length - 1] === '') {
        arr.pop();
    }
    return arr;
}
export function isPrefixArray(needle, haystack) {
    if (needle.length > haystack.length) {
        return false;
    }
    for (let i = 0; i < needle.length; i++) {
        if (needle[i].toLowerCase() !== haystack[i].toLowerCase()) {
            return false;
        }
    }
    return true;
}
export function isPostfixArray(needle, haystack) {
    if (needle.length > haystack.length) {
        return false;
    }
    for (let i = needle.length - 1, j = haystack.length - 1; i >= 0; i--, j--) {
        if (needle[i].toLowerCase() !== haystack[j].toLowerCase()) {
            return false;
        }
    }
    return true;
}
export function isPostfix(needle, haystack, isStrict) {
    if (needle.length > haystack.length) {
        return false;
    }
    if (!!isStrict && needle.length === haystack.length) {
        return false;
    }
    return haystack.lastIndexOf(needle) === haystack.length - needle.length;
}
export function prop(obj, props) {
    let prop = obj;
    if (typeof props === 'string') {
        props = props.split('.');
    }
    for (let i = 0, l = props.length; i < l; i++) {
        if (!prop) {
            return;
        }
        prop = prop[props[i]];
        if (i === l - 1) {
            return prop;
        }
    }
    return obj;
}
export function setProp(obj, props, val) {
    let prop = obj;
    if (typeof props === 'string') {
        props = props.split('.');
    }
    for (let i = 0, l = props.length; i < l; i++) {
        if (!prop) {
            return;
        }
        if (i === l - 1) {
            if (val === void 0) {
                delete prop[props[i]];
            }
            else {
                prop[props[i]] = val;
            }
            return true;
        }
        if (!prop.hasOwnProperty(props[i])) {
            prop[props[i]] = {};
        }
        prop = prop[props[i]];
    }
}
export function deleteProp(obj, props) {
    setProp(obj, props, void 0);
}
export function intersect(arr1, arr2) {
    return arr1.filter(str => arr2.includes(str));
}
export function arrayHasDuplicates(arr, keyFunction) {
    const seenKeys = {};
    const keyFunctionAvailable = _.isFunction(keyFunction);
    for (let i = 0; i < arr.length; ++i) {
        const key = keyFunctionAvailable ? keyFunction(arr[i], i) : arr[i];
        if (seenKeys.hasOwnProperty(key)) {
            return true;
        }
        seenKeys[key] = true;
    }
    return false;
}
export function mapArrayToBooleanHash(array, valueToKeyFunction) {
    if (!array) {
        return null;
    }
    if (!valueToKeyFunction) {
        valueToKeyFunction = _.identity;
    }
    const hash = {};
    array.forEach(function (item) {
        const key = valueToKeyFunction(item);
        hash[key] = true;
    });
    return hash;
}
export function mapArrayToHash(array, mappingFunction, defaultValue) {
    const hash = {};
    const defaultValueIsFunction = _.isFunction(defaultValue);
    array.forEach(function (element, index) {
        const key = mappingFunction(element, index);
        let value = element;
        if (defaultValue) {
            if (defaultValueIsFunction) {
                value = defaultValue(element, index);
            }
            else {
                value = defaultValue;
            }
        }
        hash[key] = value;
    });
    return hash;
}
export function getMinDifferentiatingPrecision(values, maxDecimalPlaces, minDecimalPlaces) {
    if (isNaN(minDecimalPlaces)) {
        minDecimalPlaces = 0;
    }
    if (values.length === 1) {
        return minDecimalPlaces;
    }
    values = values.compact().unique();
    for (let i = minDecimalPlaces; i < maxDecimalPlaces; i++) {
        const distinctValues = {};
        let duplicatesFound = false;
        for (let j = 0; j < values.length; j++) {
            const value = values[j];
            const roundedValue = Math.round(value * Math.pow(10, i));
            if (distinctValues.hasOwnProperty(roundedValue)) {
                duplicatesFound = true;
                break;
            }
            distinctValues[roundedValue] = true;
        }
        if (!duplicatesFound) {
            return i;
        }
    }
    return maxDecimalPlaces;
}
export function getAllCombinationsOfSize(array, tupleSize) {
    const cache = {};
    const recursive = function (array, tupleSize, startIndex) {
        const cacheKey = `${tupleSize},${startIndex}`;
        if (!cache.hasOwnProperty(cacheKey)) {
            let rv;
            if (tupleSize === 0) {
                rv = [[]];
            }
            else if (startIndex >= array.length) {
                rv = [];
            }
            else {
                const oneSizeLess = recursive(array, tupleSize - 1, startIndex + 1);
                const sameSize = recursive(array, tupleSize, startIndex + 1);
                for (let j = 0; j < oneSizeLess.length; j++) {
                    oneSizeLess[j].unshift(array[startIndex]);
                }
                rv = oneSizeLess.concat(sameSize);
            }
            cache[cacheKey] = copyArrayOfArrays(rv);
        }
        return cache[cacheKey];
    };
    return recursive(array, tupleSize, 0);
}
function copyArrayOfArrays(arrOArr) {
    if (arrOArr.length === 0) {
        return [];
    }
    const maxDepthReached = arrOArr[0].length === undefined;
    if (maxDepthReached) {
        return arrOArr.slice();
    }
    const rv = [];
    for (let i = 0; i < arrOArr.length; i++) {
        rv.push(copyArrayOfArrays(arrOArr[i]));
    }
    return rv;
}
export function areArraysSameSet(array1, array2) {
    array1 = array1 || [];
    array2 = array2 || [];
    array1 = _.uniq(array1);
    array2 = _.uniq(array2);
    return (array1.length === array2.length &&
        _.intersection(array1, array2).length === array1.length);
}
export function computeAxisInfinityPlaceholderValue(min, max) {
    if (min === Number.NEGATIVE_INFINITY || min === Number.POSITIVE_INFINITY) {
        return 1;
    }
    if (min === max) {
        return (max + 1) * 10;
    }
    return Math.max(Math.abs(max), Math.abs(min)) + Math.abs(max - min);
}
export function areArraysEqual(array1, array2, mappingFunction) {
    if (array1.length !== array2.length) {
        return false;
    }
    for (let i = 0; i < array1.length; ++i) {
        let value1 = array1[i];
        let value2 = array2[i];
        if (mappingFunction) {
            value1 = mappingFunction(value1);
            value2 = mappingFunction(value2);
        }
        if (value1 !== value2) {
            return false;
        }
    }
    return true;
}
export function update(target, source, deep, strict) {
    let key;
    let sourceIsObject;
    let targetIsObject;
    let sourceVal;
    let targetVal;
    let result;
    if (target) {
        for (key in source) {
            if (source.hasOwnProperty(key) && target.hasOwnProperty(key)) {
                sourceVal = source[key];
                targetVal = target[key];
                const sourceType = typeof sourceVal;
                const targetType = typeof targetVal;
                if (!!strict && sourceType !== targetType) {
                    continue;
                }
                sourceIsObject = sourceType === 'object';
                targetIsObject = targetType === 'object';
                result = sourceVal;
                if (deep && sourceIsObject && targetIsObject) {
                    update(target[key], sourceVal, deep, strict);
                    continue;
                }
                target[key] = result;
            }
        }
    }
    return target;
}
export function clearObject(object) {
    Object.keys(object).forEach(function (key) {
        delete object[key];
    });
}
export const generateStringMapFromEnum = enumObject => {
    const stringMap = Object.keys(enumObject).reduce((objMap, key) => {
        if (!parseInt(key) && key !== '0') {
            objMap[key] = key;
        }
        return objMap;
    }, {});
    return stringMap;
};
export function isDefined(value) {
    return typeof value !== 'undefined';
}
export function iterateObject(object, callback) {
    Object.keys(object).forEach(function (key) {
        callback(key, object[key]);
    });
}
export function findIndexFromLast(array, predicate) {
    const predicateIsFunction = _.isFunction(predicate);
    for (let i = array.length - 1; i >= 0; i--) {
        if (predicateIsFunction) {
            if (predicate(array[i])) {
                return i;
            }
        }
        else if (array[i] === predicate) {
            return i;
        }
    }
    return -1;
}
export function repeat(value, numRepeat) {
    if (numRepeat <= 0) {
        return [];
    }
    const array = [];
    let i = 0;
    while (i < numRepeat) {
        array[i++] = value;
    }
    return array;
}
export function getAllSplits(array, numBuckets, startIndex = 0) {
    startIndex = startIndex || 0;
    if (startIndex >= array.length) {
        return [repeat([], numBuckets)];
    }
    const newSplits = [];
    const recursiveSplits = getAllSplits(array, numBuckets, startIndex + 1);
    recursiveSplits.each(function (recursiveSplit) {
        for (let i = 0; i < numBuckets; i++) {
            const split = copyArrayOfArrays(recursiveSplit);
            split[i].unshift(array[startIndex]);
            newSplits.push(split);
        }
    });
    return newSplits.concat(recursiveSplits);
}
//# sourceMappingURL=util.js.map